<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:0em">I am thankful for the assistance provided by my husband, Ivan Arthur, for his support and encouragement. I am grateful for the assistance, ongoing encouragement and instructions received to begin my writing and organize my thoughts. I appreciate all those conversations with family members, friends, and church members, who have listened to my ideas and enhanced my learning of the gospel.</p><br/>
<p style="text-indent:0em">Even though I have considered the thoughts and assistance of other acquaintances, I am solely responsible for the concepts, ideas, and views that I have expressed in <em>Treasure in Heaven</em>. This book is not an official statement of the Church doctrine, principles, or truths.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?88387fb6